import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacyDomainCreate = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/website/domains/create',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/domains/create')({
  loader: redirectLegacyDomainCreate,
})
